<form [formGroup]="form">
  <div class="d-lg-flex align-items-center mb-2">
    <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
    @if (selectedClient) {
      <div class="d-flex">
        <label for="startDate" class="control-label required me-2">{{'i18n.domain.reports.filter.fields.startDate' | translate}}:</label>
        <ejs-datepicker #startTime
                        formControlName="startDate"
                        format="dd.MM.yyyy"
                        class="me-2"
                        id="startDate">
        </ejs-datepicker>
      </div>
      <div class="d-flex">
        <label for="endDate" class="control-label required me-2">{{'i18n.domain.reports.filter.fields.endDate' | translate}}:</label>
        <ejs-datepicker #endTime
                        formControlName="endDate"
                        format="dd.MM.yyyy"
                        class="me-2"
                        id="endDate">
        </ejs-datepicker>
      </div>
      <div class="d-flex">
        <label for="registrationType" class="control-label me-2">{{'i18n.domain.reports.filter.fields.parker-registration-type' | translate}}:</label>
        <app-enum-drop-down-list id="registrationType"
                                 formControlName="parkerRegistrationType"
                                 [showClearButton]="true"
                                 [enumType]="ParkerRegistrationType"
                                 baseTranslationString='i18n.domain.parker-registration.ParkerRegistrationType.'></app-enum-drop-down-list>
      </div>
    }
  </div>
</form>
